import React from "react";
import { BRAND_SECONDARY_RGB } from "~/brandColors";

type HappyPersonIconProps = {
  className?: string;
};

const HappyPersonIcon = ({ className = "w-16 h-16" }: HappyPersonIconProps) => (
  <svg
    className={className}
    width="137"
    height="161"
    viewBox="0 0 137 161"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M107.816 59.6313L110.262 51.4804L106.744 43.7315L114.895 46.1767L122.644 42.6595L120.199 50.8104L123.716 58.5593L115.565 56.1141L107.816 59.6313ZM114.687 71.1471L115.936 67.0699L114.151 63.1972L118.253 64.418L122.101 62.6612L120.905 66.7349L122.637 70.6111L118.588 69.3867L114.687 71.1471Z"
      fill={BRAND_SECONDARY_RGB}
    />
    <g clipPath="url(#clip0_100_12339)">
      <path
        d="M74.0233 33.0532L87.9941 27.635L94.9573 14.3666L100.375 28.3373L113.644 35.3005L99.6732 40.7187L92.71 53.9871L87.2918 40.0164L74.0233 33.0532ZM65.4533 55.0561L72.4694 52.3815L75.9203 45.7128L78.6601 52.7326L85.2636 56.1798L78.309 58.9233L74.7966 65.5231L72.1183 58.5722L65.4533 55.0561Z"
        fill={BRAND_SECONDARY_RGB}
      />
    </g>
    <g clipPath="url(#clip1_100_12339)">
      <path
        d="M41.5133 68.403L47.714 54.7615L61.3555 48.5609L47.714 42.3602L41.5133 28.7188L35.3127 42.3602L21.6712 48.5609L35.3127 54.7615L41.5133 68.403ZM19.0604 75.7133L22.1281 68.8599L28.9815 65.7922L22.1281 62.6592L19.0604 55.8711L15.9274 62.6592L9.13934 65.7922L15.9274 68.8599L19.0604 75.7133Z"
        fill={BRAND_SECONDARY_RGB}
      />
      <mask
        id="mask0_100_12339"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="44"
        y="0"
        width="34"
        height="34"
      >
        <path
          d="M56.2415 0L46.8363 6.13382L44.3828 20.0372C45.4733 21.4002 47.8178 24.2082 48.472 24.5353C49.2899 24.9442 59.5129 33.9405 60.3308 33.9405C60.985 33.9405 63.3295 29.0334 64.42 26.5799L70.5538 23.3085C72.871 20.1735 77.5055 13.8215 77.5055 13.4944C77.5055 13.1673 70.1449 6.81536 66.4646 3.68029L56.2415 0Z"
          fill={BRAND_SECONDARY_RGB}
        />
      </mask>
      <g mask="url(#mask0_100_12339)">
        <path
          d="M58.4507 30.5875L54.566 22.0411L46.0195 18.1563L54.566 14.2716L58.4507 5.7251L62.3355 14.2716L70.882 18.1563L62.3355 22.0411L58.4507 30.5875ZM72.5176 35.1674L70.5957 30.8738L66.302 28.9518L70.5957 26.989L72.5176 22.7362L74.4805 26.989L78.7333 28.9518L74.4805 30.8738L72.5176 35.1674Z"
          fill={BRAND_SECONDARY_RGB}
        />
      </g>
    </g>
    <path
      d="M73.1029 88.5494C70.9272 88.5494 69.0598 87.7698 67.5005 86.2106C65.9413 84.6513 65.1617 82.7839 65.1617 80.6082C65.1617 78.4325 65.9413 76.5651 67.5005 75.0058C69.0598 73.4466 70.9272 72.667 73.1029 72.667C75.2786 72.667 77.146 73.4466 78.7053 75.0058C80.2645 76.5651 81.0441 78.4325 81.0441 80.6082C81.0441 82.7839 80.2645 84.6513 78.7053 86.2106C77.146 87.7698 75.2786 88.5494 73.1029 88.5494ZM109.001 98.4487C105.23 99.2465 101.332 99.8992 97.3073 100.407C93.2823 100.914 89.0941 101.35 84.7427 101.712V156.539C84.7427 157.409 84.4345 158.153 83.8181 158.769C83.2016 159.386 82.422 159.694 81.4792 159.694C80.5364 159.694 79.7568 159.386 79.1404 158.769C78.5239 158.153 78.2157 157.373 78.2157 156.43V131.41H67.9901V156.539C67.9901 157.409 67.6819 158.153 67.0654 158.769C66.449 159.386 65.6693 159.694 64.7266 159.694C63.7838 159.694 63.0042 159.386 62.3877 158.769C61.7713 158.153 61.4631 157.373 61.4631 156.43V101.712C57.1117 101.35 52.9235 100.914 48.8985 100.407C44.8736 99.8992 40.9755 99.2465 37.2043 98.4487C36.334 98.2311 35.6632 97.7416 35.1918 96.9801C34.7204 96.2186 34.5935 95.3665 34.8111 94.4237C35.0286 93.5534 35.5182 92.8645 36.2796 92.3568C37.0411 91.8492 37.8933 91.7041 38.8361 91.9217C44.4203 93.1546 50.0045 94.0067 55.5887 94.4781C61.173 94.9495 67.011 95.1852 73.1029 95.1852C79.1948 95.1852 85.0328 94.9495 90.6171 94.4781C96.2013 94.0067 101.786 93.1546 107.37 91.9217C108.313 91.7041 109.183 91.831 109.981 92.3024C110.778 92.7738 111.286 93.4809 111.504 94.4237C111.721 95.294 111.576 96.128 111.068 96.9257C110.561 97.7235 109.872 98.2311 109.001 98.4487Z"
      fill={BRAND_SECONDARY_RGB}
    />
    <defs>
      <clipPath id="clip0_100_12339">
        <rect
          width="54.9415"
          height="52.4827"
          fill="white"
          transform="translate(117.826 14.5269) rotate(93.2464)"
        />
      </clipPath>
      <clipPath id="clip1_100_12339">
        <rect
          width="78.3242"
          height="75.7134"
          fill="white"
          transform="matrix(-1 0 0 1 78.3242 0)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default HappyPersonIcon; 